import React, { useState, useEffect, useCallback } from 'react';
import { verifyToken } from './api';
import AuthModal from './components/AuthModal';
import Dashboard from './pages/Dashboard';
import Pantry from './pages/Pantry';
import Settings from './pages/Settings';
import Meals from './pages/Meals';
import InStore from './pages/InStore';
import Toast from './components/Toast';
export default function App() {
  const [authed, setAuthed] = useState(null); // null = checking
  const [page, setPage] = useState('dashboard'); // dashboard, pantry, settings, instore
  const [toast, setToast] = useState(null);
  const [listData, setListData] = useState(null);

  const showToast = useCallback((msg, duration = 3000) => {
    setToast(msg);
    setTimeout(() => setToast(null), duration);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('heb_family_token');
    if (!token) { setAuthed(false); return; }
    verifyToken(token).then(ok => setAuthed(ok)).catch(() => setAuthed(false));
  }, []);

  const handleAuth = (token) => {
    localStorage.setItem('heb_family_token', token);
    setAuthed(true);
  };

  if (authed === null) {
    return <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="text-gray-400 text-lg">Loading...</div>
    </div>;
  }

  if (!authed) {
    return <AuthModal onAuth={handleAuth} />;
  }

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100">
      {/* Top bar */}
      <header className="bg-gray-800 border-b border-gray-700 px-4 py-3">
        <div className="flex gap-1">
          <button
            onClick={() => setPage('dashboard')}
            className={`px-4 py-2 rounded-lg text-sm font-medium ${page === 'dashboard' ? 'bg-red-600 text-white' : 'text-gray-400 hover:text-white'}`}
          >
            Shopping List
          </button>
          <button
            onClick={() => setPage('pantry')}
            className={`px-4 py-2 rounded-lg text-sm font-medium ${page === 'pantry' ? 'bg-red-600 text-white' : 'text-gray-400 hover:text-white'}`}
          >
            Pantry
          </button>
          <button
            onClick={() => setPage('meals')}
            className={`px-4 py-2 rounded-lg text-sm font-medium ${page === 'meals' ? 'bg-red-600 text-white' : 'text-gray-400 hover:text-white'}`}
          >
            Meals
          </button>
          <button
            onClick={() => setPage('settings')}
            className={`px-4 py-2 rounded-lg text-sm font-medium ${page === 'settings' ? 'bg-red-600 text-white' : 'text-gray-400 hover:text-white'}`}
          >
            Items
          </button>
        </div>
      </header>

      {/* Content */}
      <main className="p-4 max-w-7xl mx-auto">
        {page === 'dashboard' && <Dashboard showToast={showToast} onInStore={(data) => { setListData(data); setPage('instore'); }} onNavigate={setPage} />}
        {page === 'pantry' && <Pantry showToast={showToast} />}
        {page === 'meals' && <Meals showToast={showToast} />}
        {page === 'settings' && <Settings showToast={showToast} />}
        {page === 'instore' && <InStore listData={listData} onBack={() => setPage('dashboard')} showToast={showToast} />}
      </main>

      {toast && <Toast message={toast} onClose={() => setToast(null)} />}
    </div>
  );
}
